import styled from "styled-components";
import React, {useRef, useState, useEffect} from 'react';
import Button from "@mui/material/Button";
import Slider from '@mui/material/Slider';

const WrapperStyled = styled.div`
    width: 100%;
    margin: 0;
    text-align: center;

    video {
        width: 100%;
        max-height: 100%;
        outline: none;
    }

    .controls {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0;
    }

    .controls button {
        margin-right: 10px;
    }

    .progress {
        flex: 1;
        display: grid;
        align-items: center;
        grid-template-columns: 1fr auto auto auto;
        grid-gap: 10px;
    }

    .progress input {
        width: 100%;
        margin: 0 10px;
    }
`;

const VideoPlayer = ({videoSource, classNames}) => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    useEffect(() => {
        if (videoRef?.current) {
            videoRef.current.addEventListener('play', () => setIsPlaying(true));
            videoRef.current.addEventListener('pause', () => setIsPlaying(false));
            videoRef.current.addEventListener('timeupdate', () => {
                if (videoRef?.current?.currentTime) {
                    setCurrentTime(videoRef.current.currentTime);
                    setDuration(videoRef.current.duration);
                }
            });
        }
        return () => {

        };
    }, []);

    const playPauseToggle = () => {
        if (isPlaying) {
            videoRef?.current?.pause();
        } else {
            videoRef?.current?.play();
        }
    };

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const seekTo = (time) => {
        setCurrentTime(time);
        if (videoRef?.current?.currentTime) {
            videoRef.current.currentTime = parseInt(time);
        }
    };

    return (
        <WrapperStyled className={classNames}>
            <video
                preload="auto"
                loop
                muted
                autoPlay
                controls
                ref={videoRef}
                src={videoSource}
            />
            <div className="controls">
                <Button onClick={playPauseToggle}>{isPlaying ? 'Pause' : 'Play'}</Button>
                <div className="progress">
                    <Slider
                        min={0}
                        max={10}
                        value={currentTime}
                        onChange={(e) => seekTo(e.target.value)}
                        aria-labelledby="input-slider"
                    />
                    <span>{formatTime(currentTime)}</span> / <span>{formatTime(duration)}</span>
                </div>
            </div>
        </WrapperStyled>
    );
};

export default VideoPlayer;
